export default __webpack_public_path__ + "static/media/Ford.c6b836be.svg";